import { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { IListResponse } from '../types/list';
import { IFulfillment } from '../types/rusPost';
import { useFetch } from './useFetch';

export const useRusPostFulfillments = () => {
    const deleteFetch = useFetch();
    const fetch = useFetch();
    const [response, setResponse] = useState<IListResponse<IFulfillment>>();
    const [searchParams] = useSearchParams();
    const { t } = useTranslation();

    const page = searchParams.get('page');

    const deleteRow = (id: number) => {
        Modal.confirm({
            title: t('confirmAction'),
            content: t('deleteConfirmation'),
            onOk: () => deleteFetch.request({
                url: `/ruspost/fulfillment/${id}/delete`,
                method: 'get',
            }).then(() => getList()),
            okText: t('delete'),
        });
    };

    const getList = async () => {
        let url = '/ruspost/fulfillment';

        if (typeof page === 'string') {
            url += `?page=${page}`;
        }

        const result = await fetch.request({
            url,
            method: 'post',
            data: {
                sorters: [{ column: 'id', desc: true }],
            },
        });

        if (result.success) {
            setResponse(result.data);
        }
    };

    useEffect(() => {
        getList();
    }, [page]);

    return {
        response,
        deleteRow,
        loading: fetch.loading,
    };
};
